import { render, staticRenderFns } from "./cardPedidos.vue?vue&type=template&id=41f1a287&scoped=true"
import script from "./cardPedidos.vue?vue&type=script&lang=js"
export * from "./cardPedidos.vue?vue&type=script&lang=js"
import style0 from "./cardPedidos.vue?vue&type=style&index=0&id=41f1a287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1a287",
  null
  
)

export default component.exports